export default __webpack_public_path__ + "static/media/Tick1.96ecf32b.mp3";